import XInputDesignView from './xInputDesignView.vue';
import XInputPropForm from './xInputPropForm.vue';

import { XInput } from '@xui/components';

export { createFormDesignWidgetConfig } from './config';

export const renderFormDesignWidgetView = (renderOpts, renderParams) => {
    return <XInputDesignView renderOpts={renderOpts} renderParams={renderParams} />;
};

export const renderFormDesignWidgetFormView = (renderOpts, renderParams) => {
    return (
        <XInputPropForm renderOpts={renderOpts} renderParams={renderParams} />
    );
};

export const renderFormItemContent = (renderOpts, params = {}) => {
    const { field, data = {} } = params || {};
    const { props = {} } = renderOpts || {};
    return <XInput value={data[field]} onUpdate:value={(value => { data[field] = value; })} {...props}></XInput>;
};
